import { render } from "./ProjectPublicationHistoryListItemAccount.vue?vue&type=template&id=6fcddfac&scoped=true"
import script from "./ProjectPublicationHistoryListItemAccount.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationHistoryListItemAccount.vue?vue&type=script&lang=js"

import "./ProjectPublicationHistoryListItemAccount.vue?vue&type=style&index=0&id=6fcddfac&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcddfac"]])

export default __exports__